import termsData from "../../pages/SelectEzi_Landing_Page/Policies/General_Terms/data/termsData.json";

/**
 * Resolves the appropriate terms object based on termsId, termsType, form title, or current pathname.
 */
export const resolveTerms = ({
  termsId,
  termsType,
  title = "",
  pathname = "",
} = {}) => {
  // 1. Direct ID lookup
  if (termsId) {
    const directMatch = termsData.find(
      (t) => t.id?.toLowerCase() === String(termsId).toLowerCase()
    );
    if (directMatch) return directMatch;
  }

  // 2. Combine signals
  const combined = `${termsType || ""} ${title || ""} ${pathname || ""}`.toLowerCase();

  // Retailer / New items
  if (combined.includes("retail") || combined.includes("newitem") || combined.includes("new items")) {
    return termsData.find((t) => t.id === "retailer-showcase") || termsData[0];
  }

  // Raw Material
  if (combined.includes("raw material") || combined.includes("rawmaterial") || combined.includes("raw_material") || combined.includes("raw-material")) {
    return termsData.find((t) => t.id === "raw-material-showcase") || termsData[0];
  }

  // Manufacturer
  if (combined.includes("manufactur")) {
    return termsData.find((t) => t.id === "manufacturer-showcase") || termsData[0];
  }

  // Wholesaler
  if (combined.includes("wholesal") || combined.includes("wholsell") || combined.includes("wholeseller")) {
    return termsData.find((t) => t.id === "wholseller-showcase") || termsData[0];
  }

  // Homemade items
  if (combined.includes("homemade") || combined.includes("home made")) {
    return termsData.find((t) => t.id === "home-made-items-shop") || termsData[0];
  }

  // Farming items
  if (combined.includes("farm") || combined.includes("agricultur") || combined.includes("restaurant")) {
    return termsData.find((t) => t.id === "farming-items-showcase") || termsData[0];
  }

  // Gems and Jewelry / Minerals & Mining
  if (
    combined.includes("gem") ||
    combined.includes("jewel") ||
    combined.includes("mineral") ||
    combined.includes("mining")
  ) {
    return termsData.find((t) => t.id === "jems-jewaley-showcase") || termsData[0];
  }

  // Used Vehicles
  if (
    combined.includes("used vehicle") ||
    combined.includes("vehicle") ||
    combined.includes("car")
  ) {
    return termsData.find((t) => t.id === "used-vehicle-showcase") || termsData[0];
  }

  // 2nd Hand / Used Items
  if (
    combined.includes("used item") ||
    combined.includes("used items") ||
    combined.includes("2nd hand") ||
    combined.includes("second-hand") ||
    combined.includes("used")
  ) {
    return termsData.find((t) => t.id === "second-hand-items-showcase") || termsData[0];
  }

  // Recycling Material
  if (combined.includes("recycle") || combined.includes("recycling")) {
    return termsData.find((t) => t.id === "recycling-materail-showcase") || termsData[0];
  }

  // Food Services
  if (combined.includes("food")) {
    return termsData.find((t) => t.id === "foods-services") || termsData[0];
  }

  // Jobs Offering
  if (combined.includes("job")) {
    return termsData.find((t) => t.id === "jobs-offering-companies") || termsData[0];
  }

  // Real Estate / Property
  if (
    combined.includes("property") ||
    combined.includes("real estate") ||
    combined.includes("real-estate") ||
    combined.includes("real state")
  ) {
    return termsData.find((t) => t.id === "real-state-services") || termsData[0];
  }

  // Service Provider
  if (combined.includes("service")) {
    return termsData.find((t) => t.id === "service-provider-showcase") || termsData[0];
  }

  // Transportation
  if (combined.includes("transport")) {
    return termsData.find((t) => t.id === "transportation-service-showcase") || termsData[0];
  }

  // Prohibited Products
  if (combined.includes("prohibit")) {
    return termsData.find((t) => t.id === "prohibited-products-services") || termsData[0];
  }

  // Fallback to General Terms
  return termsData.find((t) => t.id === "general-terms") || termsData[0];
};

export default resolveTerms;

